import { Users } from 'src/app/shared/models';
import { MemoizedSelector, createFeatureSelector, createSelector } from '@ngrx/store';
import { UserState } from './state';

export const selectUsersState: MemoizedSelector<object, UserState> = createFeatureSelector<UserState>('users');

const getUsersList = (state: UserState): Users[] => state.list;
const getUserDetails = (state: UserState): Users | null => state.details;

export const selectUsersList: MemoizedSelector<object, Users[]> = createSelector(selectUsersState, getUsersList);

export const selectUserDetails: MemoizedSelector<object, Users | null> = createSelector(
  selectUsersState,
  getUserDetails,
);
